<template>
  <v-form>
    <v-progress-linear
      v-if="loading"
      indeterminate
      color="blue"
    ></v-progress-linear>
    <v-card class="pa-5" v-if="!this.secret">
      <HeaderDividerBlock headerText="Update User"></HeaderDividerBlock>
      <v-container>
        <v-layout row v-if="errors">
          <v-flex>
            <Alert @dismissed="onDismissed" :text="errors"></Alert>
          </v-flex>
        </v-layout>
        <v-row>
          <v-col cols="6">
            <v-text-field
              outlined
              dense
              v-model="form.employer_no"
              required
              label="Employee ID*"
              :error-messages="this.fieldErrors.employer_no"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              outlined
              dense
              v-model="form.full_name"
              required
              label="Full Name*"
              :error-messages="this.fieldErrors.full_name"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              outlined
              dense
              v-model="form.email"
              required
              label="Email*"
              :error-messages="this.fieldErrors.email"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-select
              v-model="form.role_name"
              :items="role_names"
              :item-text="'name'"
              :item-value="'name'"
              label="Role*"
              dense
              outlined
              multiple
              :error-messages="this.fieldErrors.role_name"
            ></v-select>
          </v-col>
          <v-col cols="6">
            <v-autocomplete
              v-model="form.speciality"
              :items="specialities"
              label="Speciality*"
              :item-text="'name'"
              :item-value="'uuid'"
              dense
              outlined
              clearable
              :error-messages="this.fieldErrors.speciality"
            ></v-autocomplete>
          </v-col>
          <v-col cols="6">
            <v-text-field
              outlined
              dense
              v-model="form.cph"
              required
              :label="`Cost Per Hour* (${currencyCode})`"
              :error-messages="this.fieldErrors.cost_per_hour"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              outlined
              dense
              v-model="form.phone"
              required
              label="Phone"
              :error-messages="this.fieldErrors.phone"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              outlined
              dense
              v-model="form.mobile"
              required
              label="Mobile"
              :error-messages="this.fieldErrors.mobile"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              outlined
              dense
              v-model="form.address1"
              label="Address 01"
              :error-messages="this.fieldErrors.address1"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              outlined
              dense
              v-model="form.address2"
              label="Address 02"
              :error-messages="this.fieldErrors.address2"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              outlined
              dense
              v-model="form.city"
              label="City"
              :error-messages="this.fieldErrors.city"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              outlined
              dense
              v-model="form.state"
              label="State"
              :error-messages="this.fieldErrors.state"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-autocomplete
              v-model="form.branch"
              :items="branches"
              label="Branch"
              :item-text="'name'"
              :item-value="'uuid'"
              dense
              outlined
              clearable
              :error-messages="this.fieldErrors.branch"
            ></v-autocomplete>
          </v-col>
          <v-col cols="6">
            <v-text-field
              outlined
              dense
              v-model="form.country"
              label="Country"
              :error-messages="this.fieldErrors.country"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>
      <v-divider></v-divider>
      <v-card-actions>
        <v-row>
          <v-col cols="12" md="9" xs="6"> </v-col>
          <v-col cols="12" md="3" xs="6">
            <v-btn
              large
              color="#00B3FF"
              dark
              depressed
              :loading="loading"
              block
              @click="update()"
              >Update User</v-btn
            >
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>

    <v-card v-if="this.secret" class="my-card2">
      <HeaderDividerBlock
        headerText="Google Authentication"
      ></HeaderDividerBlock>
      <v-container class="pa-6">
        <v-layout row v-if="errors">
          <v-flex>
            <Alert @dismissed="onDismissed" :text="errors"></Alert>
          </v-flex>
        </v-layout>
        <v-row>
          <v-col cols="12">
            <p>
              Set up your two factor authentication by scanning the barcode
              below. Alternatively, you can use the code
              <strong>{{ secret }}</strong>
            </p>
          </v-col>
          <v-col cols="12">
            <div v-html="QR"></div>
          </v-col>
        </v-row>
      </v-container>
      <v-divider></v-divider>
      <v-card-actions>
        <v-row>
          <v-col cols="12" md="9" xs="6"> </v-col>
          <v-col cols="12" md="3" xs="6">
            <v-btn
              large
              color="#00B3FF"
              dark
              depressed
              :loading="loading"
              block
              @click="update1()"
              >Update</v-btn
            >
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>

    <Snackbars
      :text="successMsg"
      :snackbar="snackbar"
      :color="'success'"
      @classSnackbar="closeSnackbar"
    />
    <Snackbars
      :text="'Validation error please scroll up'"
      :snackbar="snackbarError"
      :color="'red'"
      @classSnackbar="closeSnackbar"
    />
  </v-form>
</template>

<script>
import Alert from "@/components/shared/Alert";
import { EmployerService } from "@/services/employer-service.js";
import { checkError } from "@/config/errors.js";
import { ProjectService } from "@/services/project-service.js";
import Snackbars from "@/components/shared/Snackbars";
import HeaderDividerBlock from "@/components/shared/HeaderDividerBlock";
import { createNamespacedHelpers } from "vuex";
const { mapGetters: mapSettingsGetters } = createNamespacedHelpers('settings');


export default {
  name: "CreateEmployer",
  components: { Alert, Snackbars, HeaderDividerBlock },
  props: ["name"],
  data: () => ({
    form: {
      employer_no: "",
      full_name: "",
      email: "",
      status: "",
      address1: "",
      address2: "",
      city: "",
      state: "",
      phone: "",
      mobile: "",
      speciality: "",
      cph: "",
      google2fa: null,
      country: "",
    },

    states: ["ACT", "NSW", "NT", "QLD", "SA", "TAS", "VIC", "WA"],

    snackbar: false,
    secret: false,
    QR: "",
    employer_data: "",
    checker: false,
    snackbarError: false,
    successMsg: "Employer updated successfully",
    errors: null,
    loading: false,
    role_names: [],
    specialities: [],
    branches: [],
    fieldErrors: [],
  }),

  watch: {
    "form.email": function(newEmail, oldEmail) {
      if (newEmail !== oldEmail && oldEmail !== "") {
        this.checker = true;
      }
    },
  },
  
  computed: {
    ...mapSettingsGetters({
      currencyCode: 'currencyCode',
    }),
  },

  mounted() {
    this.getRolesList();
    this.getEmployerInfo();
    this.getSpecialities();
    this.getProjectBranches();
  },

  methods: {
    update() {
      this.errors = null;
      this.loading = true;
      let fd = new FormData();

      fd.append("employer_no", this.form.employer_no);
      fd.append("full_name", this.form.full_name);
      fd.append("email", this.form.email);
      fd.append("address1", this.form.address1 || "");
      fd.append("address2", this.form.address2 || "");
      fd.append("city", this.form.city || "");
      fd.append("state", this.form.state || "");
      fd.append("country", this.form.country || "");
      fd.append("role_name", this.form.role_name || "");
      fd.append("phone", this.form.phone || "");
      fd.append("mobile", this.form.mobile || "");
      fd.append("cost_per_hour", this.form.cph || "");

      if (this.form.branch && this.form.branch.uuid) {
        fd.append("branch", this.form.branch.uuid);
      } else {
        fd.append("branch", null);
      }

      if (this.form.speciality == null) {
        fd.append("speciality", "");
      } else if (typeof this.form.speciality === "object") {
        fd.append("speciality", this.form.speciality.uuid || "");
      } else {
        fd.append("speciality", this.form.speciality || "");
      }

      if (
        Array.isArray(this.form.role_name) &&
        this.form.role_name.every((obj) => typeof obj === "object")
      ) {
        this.uuidArray = this.form.role_name.map((obj) => obj.name);
        fd.append("role_name", this.uuidArray);
      } else {
        fd.append("role_name", this.form.role_name);
      }

      if (this.checker && this.form.google2fa !== null) {
        this.loading = true;
        EmployerService.updateEmployer1(this.$route.params.uuid, fd)
          .then((response) => {
            this.loading = false;
            if (response.data) {
              this.QR = response.data["QR_Image"];
              this.secret = response.data["registration_data"].google2fa_secret;
              this.employer_data = response.data["registration_data"];
            }
          })
          .catch((error) => {
            this.loading = false;
            let data = error.response.data;
            let errorOutput = checkError.errorFormatting(data);
            this.fieldErrors = data.errors;
            this.errors = errorOutput;
            window.scrollTo(0, 0);
          });
      } else {
        this.loading = true;
        EmployerService.updateEmployerById(this.$route.params.uuid, fd)
          .then((response) => {
            this.loading = false;
            if (response.data) {
              this.snackbar = true;
              this.snackbarError = false;
            }
          })
          .catch((error) => {
            this.loading = false;
            let data = error.response.data;
            let errorOutput = checkError.errorFormatting(data);
            this.fieldErrors = data.errors;
            this.errors = errorOutput;
            window.scrollTo(0, 0);
          });
      }
    },

    update1() {
      this.loading = true;
      EmployerService.updateEmployerById(
        this.$route.params.uuid,
        this.employer_data
      )
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.snackbar = true;
            this.snackbarError = false;
            this.checker = false;
            this.secret = null;
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.fieldErrors = data.errors;
          this.errors = errorOutput;
          window.scrollTo(0, 0);
        });
    },

    closeSnackbar() {
      this.snackbar = false;
    },

    getEmployerInfo() {
      this.loading = true;
      EmployerService.getEmployerInfoByUuid(this.$route.params.uuid)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            const employerData = response.data.data;
            this.setDefaultFormValues(employerData);
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    getSpecialities() {
      this.loading = true;
      EmployerService.getSpecialities()
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.specialities = response.data.data;
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    setDefaultFormValues(customerData) {
      this.form = {
        ...this.form,

        full_name: customerData.full_name || "",
        employer_no: customerData.employer_no || "",
        email: customerData.email || "",
        address1: customerData.address1 || "",
        address2: customerData.address2 || "",
        city: customerData.city || "",
        phone: customerData.phone || "",
        mobile: customerData.mobile || "",
        state: customerData.state || "",
        role_name: customerData.roles || "",
        speciality: customerData.speciality || "",
        cph: customerData.cph || "",
        google2fa: customerData.google2fa || null,
        branch: customerData.branch || "",
        country: customerData.country || "",
      };
    },

    getRolesList() {
      this.loading = true;
      EmployerService.getRolesList()
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.role_names = response.data;
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    getProjectBranches() {
      this.loading = true;
      ProjectService.getProjectBranches()
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.branches = response.data.data;
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    onDismissed() {
      this.errors = null;
    },

    reset() {
      this.form = [];
    },
  },
};
</script>
